const { shift, DEFAULT_RULES } = require("./engine");
function createDemoDataset(date = new Date().toISOString().slice(0, 10)) {
  const providers = [
    { id: "demo-rivera", name: "Dr. Alex Rivera", specialty: "Family medicine", timezone: "America/New_York", hours: "08:00–17:00" },
    { id: "demo-chen", name: "Dr. Morgan Chen", specialty: "Internal medicine", timezone: "America/New_York", hours: "09:00–18:00" },
    { id: "demo-patel", name: "Dr. Sam Patel", specialty: "Family medicine", timezone: "America/New_York", hours: "08:00–16:00" }
  ];
  const data = { source: "demo", scope: "clinic", asOf: new Date().toISOString(), seedDate: date,
    selfProviderId: providers[0].id, providers, patients: [], appointments: [], documents: [], gaps: [], billing: [], capacity: [], engagement: [], alertStates: {},
    available: ["appointments", "documents", "gaps", "billing", "valuation", "capacity", "patients", "engagement"],
    rules: { ...DEFAULT_RULES, approved: false } };
  const names = ["Jordan Ellis", "Taylor Brooks", "Casey Reed", "Avery Lane", "Riley Hayes", "Cameron Wells", "Quinn Parker", "Drew Morgan", "Skyler James", "Rowan Blake", "Emery Scott", "Finley Ross"];
  const labels = ["Preventive screening review", "Follow-up care review", "Medication review", "Annual wellness review"];
  providers.forEach((provider, pi) => {
    for (let i = 0; i < names.length; i++) {
      const id = provider.id + "-patient-" + i;
      data.patients.push({ id, providerId: provider.id, name: names[i] + " · " + (pi + 1), patientName: names[i] + " · " + (pi + 1),
        followUpStart: shift(date, -45), followUpDue: shift(date, i % 3 === 0 ? -7 : 7) });
      for (let g = 0; g < 3; g++) {
        const closed = (i + g) % 3 === 0;
        data.gaps.push({ id: id + "-gap-" + g, patientId: id, providerId: provider.id, patientName: names[i] + " · " + (pi + 1),
          label: labels[(i + g) % labels.length], priority: g === 0 && i % 4 === 0 ? "high" : g === 1 ? "medium" : "low",
          status: closed ? "closed" : "open", identifiedAt: shift(date, -(7 + ((i * 3 + g * 9) % 55))),
          closedAt: closed ? shift(date, -(i % 5)) : null, dueDate: shift(date, -(i + g + 1) * 3),
          owner: provider.name, reviewed: false, version: 1,
          evidence: "Synthetic care-gap example for product review. Priority is illustrative." });
      }
    }
    for (let offset = 189; offset >= 0; offset--) {
      const day = shift(date, -offset);
      const weekDay = new Date(day + "T12:00:00Z").getUTCDay();
      if (offset !== 0 && (weekDay === 0 || weekDay === 6)) continue;
      const volume = offset < 30 ? 11 : 8;
      data.capacity.push({ id: provider.id + "-" + day, providerId: provider.id, date: day, slots: 12 });
      for (let i = 0; i < volume; i++) {
        const patientIndex = (i + offset) % names.length;
        const patientId = provider.id + "-patient-" + patientIndex;
        const id = provider.id + "-" + day + "-" + i;
        const status = offset === 0 && i > 6 ? "scheduled" : patientIndex === 2 && offset % 2 === 0 ? "no_show" : (offset + i + pi) % 29 === 0 ? "cancelled" : "completed";
        const patientName = names[patientIndex] + " · " + (pi + 1);
        data.appointments.push({ id, providerId: provider.id, patientId, patientName, date: day, status, time: String(8 + Math.floor(i / 2)).padStart(2, "0") + ":" + (i % 2 ? "30" : "00") });
        if (status !== "completed") continue;
        const pending = offset < 4 && i % 4 === 0;
        const afterHours = (i + offset) % (pi === 0 ? 3 : 6) === 0;
        data.documents.push({ id: id + "-note", appointmentId: id, providerId: provider.id, patientId, patientName, date: day,
          status: pending ? "draft" : "finalized", activeMinutes: Math.round((offset < 30 ? 5.5 : 8.2) * 10 + (i % 4) * 3) / 10,
          aiMinutes: 0.8, afterHours, finalizedAt: pending ? null : day + (afterHours ? "T23:15:00Z" : "T15:15:00Z"), postedAt: null, version: 1 });
        if (!pending) {
          const original = [
            { code: "DEMO-A", modifier: "", units: 1, supported: true, estimatedValue: 95, evidence: "Synthetic encounter documentation supports demo service A." },
            { code: "DEMO-B", modifier: "", units: 1, supported: true, estimatedValue: 35, evidence: "Synthetic review activity supports demo service B." }
          ];
          const removed = (i + offset) % (offset < 30 ? 7 : 4) === 0;
          const final = removed ? original.slice(0, 1) : [...original];
          if (i === 5) final.push({ code: "DEMO-C", modifier: "", units: 1, supported: false, estimatedValue: 0 });
          data.billing.push({ id: id + "-coding", appointmentId: id, providerId: provider.id, patientId, patientName, date: day, original, final, version: 1 });
        }
        data.engagement.push({ id: id + "-intake", providerId: provider.id, patientId, date: day, type: "intake", completed: i % (offset < 30 ? 8 : 3) !== 0 });
        data.engagement.push({ id: id + "-review", providerId: provider.id, patientId, date: day, type: "recommendation", completed: i % 5 !== 0 });
        if (i % 3 === 0) data.engagement.push({ id: id + "-portal", providerId: provider.id, patientId, date: day, type: "portal", completed: true });
      }
    }
  });
  return data;
}
module.exports = { createDemoDataset };
